import { Link } from "react-router-dom";
import { SingleCooperativeMember } from "../../redux/features/cooperative/cooperative.type";
import { Icon } from "../icons/icon";
import { CooperativeProfilePic } from "../profile/cooperativePicture";
import { CooperativeMemberCount } from "./cooperativeMemberCount";

export const MyCooperativeCard = ({
  memberData,
  handleClick,
}: {
  memberData: SingleCooperativeMember;
  handleClick: () => void;
}) => {
  return (
    <Link
      className="
      flex flex-row flex-wrap items-center justify-between
      w-full gap-4
      hover:scale-[0.99] transition-all duration-300 cursor-pointer
      "
      to={`/app/my-cooperatives/${encodeURIComponent(
        memberData.Cooperative.CoopName
      )}/${memberData.Cooperative.id}`}
      onClick={(e) => {
        e.preventDefault();
        handleClick();
      }}
    >
      <CooperativeProfilePic
        cooperative={memberData.Cooperative}
        className="!w-[40px] !h-[40px] md:!w-[64px] md:!h-[64px]"
      />

      <div className="flex-1">
        <p className="text-base text-pry-dark-green-100 font-medium">
          {memberData?.Cooperative?.CoopName}
        </p>
        <CooperativeMemberCount
          cooperative={memberData.Cooperative}
          className="!mt-1 !text-pry-green-200 !bg-light-green-bg-300"
        />
      </div>

      <p
        className={`
          ${
            memberData.isApprove
              ? "text-pry-green-200 bg-light-green-bg-500"
              : "text-pry-dark-green-300/50 bg-light-green-bg"
          }
          px-4 py-2 rounded-[4px] flex flex-row
          gap-[10px] text-sm font-medium w-full md:w-fit
          items-center justify-center
          `}
      >
        {memberData.isApprove && (
          <Icon svg={"verified"} width={20} height={20} />
        )}
        <span>{memberData.isApprove ? "Registered" : undefined}</span>
        <span>
          {!memberData.isApprove &&
          memberData.hasPaid &&
          memberData.isPaymentRequired
            ? "Awaiting Approval"
            : undefined}
        </span>
        <span>
          {!memberData.isApprove && !memberData.isPaymentRequired
            ? "Awaiting Approval"
            : undefined}
        </span>
        <span>
          {!memberData.isApprove &&
          !memberData.hasPaid &&
          memberData.isPaymentRequired
            ? "Awaiting Payment"
            : undefined}
        </span>
      </p>
    </Link>
  );
};
